import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {SessionService} from '../../../core/service/session.service';
import {MasterService} from '../../../core/service/master.service';
import {AlertService} from '../../../core/service/alert.service';
import {Alert} from '../../interfaces/alert';

@Component({
  selector: 'app-alert-edit-dialog',
  templateUrl: './alert-edit-dialog.component.html',
  styleUrls: ['./alert-edit-dialog.component.scss',
    './../../layout/layout.component.scss']
})
export class AlertEditDialogComponent implements OnInit {
  alert: Alert;
  constructor(@Inject(MAT_DIALOG_DATA) public data: Alert,
              public matDialogRef: MatDialogRef<AlertEditDialogComponent>,
              public commonService: CommonService,
              public sessionService: SessionService,
              public alertService: AlertService,
              public masterService: MasterService,) {
    this.alert = this.data;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.alert.kakuninDate = this.commonService.getDateWithString();
    if (!this.alert.kakuninOperator) {
      this.alert.kakuninOperator = this.sessionService.session.personalSetting.name;
    }
  }

  /**
   *
   */
  register() {
    // this.alert.kakuninOperatorAddress = this.sessionService.session.personalSetting.mail;
    this.alertService.updateAlert(this.alert).then(() => {this.commonService.onClick(this.matDialogRef);}).catch();
  }
}
